<template>
  <div>
    <template v-for="channel in channels">
      <v-btn
        :key="`channel_${channel.value}`"
        :color="value == channel.fullValue ? 'primary' : 'grey'"
        :outline="value != channel.fullValue"
        class="ma-0 mr-1 mb-1"
        depressed
        @click="onchange(channel.fullValueForUse)"
      >
        <em v-if="channel.icon" :class="`${channel.icon} mr-1`" />{{ $t(channel.text) }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import LivechatSocialChannel from '@/components/view/livechat/LivechatSocialChannelMixin'
import { PAGE, PAGE_GROUP } from '@/constants/page.js'
import { mapGetters } from 'vuex'

export default {
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  mixins: [LivechatSocialChannel],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    channels() {
      let channels = this.handleGetChannelOptions(this.$store.getters.selectedBot)
      if ([...PAGE.JORAKAY, ...PAGE.OCEAN_PSYJAI].includes(this.selectedBot.pageid)) {
        channels = channels.filter((item) => ['webchat'].includes(item.fullValue))
      }
      return [
        {
          value: 'all',
          fullValue: 'all',
          fullValueForUse: 'all',
          text: 'All',
          icon: ''
        },
        ...channels
      ]
    }
  },
  methods: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onchange(value) {
      this.$emit('input', value)
      this.$emit('changeChannel', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DashboardSelectChannel.vue